import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { CDN_URL, formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaArrowCircleRight, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";

export default function OneService({ data }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'event',
      extraItem: data.uuid,
    })
  }

  const coverUrl = (data && data.coverPhoto) ? (CDN_URL + data.coverPhoto) : "";

  return (
    <div
      className=""
      style={{
        cursor: "pointer",
        borderRadius: "18px",
        overflow: "hidden",
        marginBottom: "18px",
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
        transition: "transform 160ms ease, box-shadow 160ms ease",
      }}

      onClick={() => {
        view();
      }}

      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 16px 42px rgba(0,0,0,0.12)";
      }}

      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0px)";
        e.currentTarget.style.boxShadow = "0 10px 28px rgba(0,0,0,0.08)";
      }}
    >

      {/* Media */}
      <div
        style={{
          width: "100%",
          height: "240px",
          backgroundImage: coverUrl ? `url(${coverUrl})` : "none",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          position: "relative",
          backgroundColor: "rgba(0,0,0,0.05)",
        }}
      >

        {/* Soft gradient overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(180deg, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0.25) 35%, rgba(0,0,0,0.65) 100%)",
          }}
        />

        {/* Top subtle badge */}
        <div
          style={{
            position: "absolute",
            top: "12px",
            left: "12px",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "7px 10px",
            borderRadius: "999px",
            background: "rgba(255,255,255,0.16)",
            border: "1px solid rgba(255,255,255,0.18)",
            backdropFilter: "blur(10px)",
          }}
        >
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.92)",
              display: "inline-block"
            }}
          />
          <span
            className="font-semi-bold"
            style={{
              fontSize: "12px",
              color: "rgba(255,255,255,0.92)"
            }}
          >
            Event
          </span>
        </div>

        {/* Bottom content */}
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            padding: "16px",
          }}
        >

          <h6
            style={{
              fontSize: "18px",
              margin: 0,
              color: "#fff",
              lineHeight: "1.3",
              textTransform: "uppercase",
              textShadow: "0 10px 26px rgba(0,0,0,0.35)",
              wordBreak: "break-word",
            }}
            className="font-bold"
          >
            {data.title}
          </h6>

          {/* Action row */}
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px"
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "7px 10px",
                borderRadius: "12px",
                background: "rgba(0,0,0,0.28)",
                border: "1px solid rgba(255,255,255,0.16)",
                backdropFilter: "blur(10px)",
                color: "rgba(255,255,255,0.92)",
                fontSize: "12px"
              }}
              className="font-semi-bold"
            >
              Tap to view
            </div>

            <div
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "999px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.16)",
                border: "1px solid rgba(255,255,255,0.18)",
                backdropFilter: "blur(10px)"
              }}
            >
              <FaArrowCircleRight
                style={{
                  color: "rgba(255,255,255,0.92)",
                  fontSize: "18px"
                }}
              />
            </div>
          </div>

        </div>

      </div>

    </div>
  )

}
